export function hasSpeechRecognitionSupport(): boolean {
  return (
    typeof window !== 'undefined' &&
    (
      typeof window.SpeechRecognition === 'function' ||
      typeof window.webkitSpeechRecognition === 'function'
    )
  );
}